import React from 'react';
import '../css_components/AboutUs.css';

const AboutUs = () => {
  const sectionSpacing = { padding: '60px 0' };
  const cardStyle = {
    background: 'linear-gradient(180deg, #1e4762 0%, #1a2940 100%)',
    color: '#e5e2e2',
    border: '2px solid #353d4d',
    padding: '30px',
    borderRadius: '16px',
    boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
    height: '100%',
    transition: 'transform 0.3s ease',
  };
  const iconStyle = { width: '70px', marginBottom: '20px' };
  const roundedImg = { borderRadius: '16px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' };

  return (
    <div style={{ backgroundColor: '#b9b3af', color: '#131312', paddingBottom: '50px' }}>

      {/* Hero Section */}
      <div className='hero-section'
        style={{
          backgroundImage: 'url(/img/hero_sec.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '400px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          color: 'white',
          fontFamily: 'Roboto, sans-serif',
          fontWeight: '900',
          fontSize: '2.8rem',
          textShadow: '2px 2px 8px rgba(0, 0, 0, 0.4)',
        }}
      >
        About InkMudra
      </div>

      {/* Who We Are */}
      <div className="container py-5 who-we-are" style={sectionSpacing}>
  <div className="row align-items-center g-4">
    {/* Text first on phones, image right on desktop */}
    <div className="col-12 col-md-6 order-2 order-md-1 d-flex text-mob">
      <div className="mx-auto" style={{ maxWidth: '56ch' }}>
        <h2 className="fw-bold mb-3" style={{ fontSize: 'clamp(1.6rem, 2.2vw + 0.6rem, 2.1rem)' }}>
          Who We Are
        </h2>
        <p className="mb-0" style={{ fontSize: 'clamp(1rem, 0.6vw + 0.9rem, 1.1rem)', lineHeight: 1.7 }}>
          At <strong>InkMudra</strong>, every print tells a story. From student blackbook printing to
          professional marketing materials, we craft excellence with every drop of ink.
          <br /><br />
          We are passionate innovators, driven to make premium printing affordable, fast, and accessible — 
          empowering students, businesses, and creatives alike.
        </p>
      </div>
    </div>

    {/* Image second on phones, left on desktop */}
    <div className="col-12 col-md-6 order-2 order-md-2 who-img">
      <div className="ratio ratio-4x3">
        <img
          src="/img/about_us_1.jpg"
          alt="Printing Services"
          loading="lazy"
          className="w-100 h-100 rounded-4 shadow-sm"
          style={{ objectFit: 'cover' }}   /* keeps crop nice on all screens */
        />
      </div>
    </div>
  </div>
</div>


      {/* Highlights */}
      {/* <div className="container" style={sectionSpacing}>
        <h2 className="fw-bold text-center mb-5" style={{fontWeight: '700'}}>Why Choose InkMudra?</h2>
        <div className="row text-center g-4">
          {[
            {
              img: "https://cdn-icons-png.flaticon.com/512/2721/2721201.png",
              title: "Efficient Printing Solution",
              desc: "Precision and quality in every print. We bring your ideas to life through efficient processes."
            },
            {
              img: "https://cdn-icons-png.flaticon.com/512/2190/2190552.png",
              title: "Cost Effective",
              desc: "Affordable solutions without compromising quality. Best value for your money with InkMudra."
            },
            {
              img: "https://cdn-icons-png.flaticon.com/512/2942/2942756.png",
              title: "Faster Turnaround Time",
              desc: "We understand deadlines. Reliable, on-time delivery for all your urgent printing needs."
            },
            {
              img: "https://cdn-icons-png.flaticon.com/512/3062/3062634.png",
              title: "Precision & Quality",
              desc: "Every print crafted to perfection. Stunning clarity, vivid colors, professional finish — every time."
            },
            {
              img: "https://cdn-icons-png.flaticon.com/512/190/190411.png",
              title: "Reliable Printing Services",
              desc: "Trusted by thousands. Consistent quality, competitive prices, and excellent customer support."
            }
          ].map((item, idx) => (
            
            <div className={`col-md-${idx < 3 ? '4' : '6'}`} key={idx}>
              <div style={cardStyle}>
                <img src={item.img} alt={item.title} style={iconStyle} />
                <h4 className="fw-bold mb-3">{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div> */}

      <div className="container" style={sectionSpacing}>
  <h2 className="fw-bold text-center mb-5" style={{ fontWeight: 700 }}>
    Why Choose InkMudra?
  </h2>

  <div className="row text-center g-3 g-md-4">
    {[
      {
        img: "https://cdn-icons-png.flaticon.com/512/2721/2721201.png",
        title: "Efficient Printing Solution",
        desc: "Precision and quality in every print. We bring your ideas to life through efficient processes."
      },
      {
        img: "https://cdn-icons-png.flaticon.com/512/2190/2190552.png",
        title: "Cost Effective",
        desc: "Affordable solutions without compromising quality. Best value for your money with InkMudra."
      },
      {
        img: "https://cdn-icons-png.flaticon.com/512/2942/2942756.png",
        title: "Faster Turnaround Time",
        desc: "We understand deadlines. Reliable, on-time delivery for all your urgent printing needs."
      },
      {
        img: "https://cdn-icons-png.flaticon.com/512/3062/3062634.png",
        title: "Precision & Quality",
        desc: "Every print crafted to perfection. Stunning clarity, vivid colors, professional finish — every time."
      },
      {
        img: "https://cdn-icons-png.flaticon.com/512/190/190411.png",
        title: "Reliable Printing Services",
        desc: "Trusted by thousands. Consistent quality, competitive prices, and excellent customer support."
      }
    ].map((item, idx) => {
      // For mobile: first 4 items are col-6 (two per row), last is col-12 (full width)
      const mobileClass = idx < 4 ? 'col-6' : 'col-12';
      // For desktop: first 3 are col-md-4, last 2 are col-md-6
      const desktopClass = idx < 3 ? 'col-md-4' : 'col-md-6';
      return (
        <div className={`${mobileClass} ${desktopClass} `} key={idx}>
          <div style={cardStyle} className="h-100 p-3 p-md-4 d-flex flex-column align-items-center justify-content-center cards">
            <img src={item.img} alt={item.title} style={iconStyle} />
            <h4 className="fw-bold mb-2 mb-md-3 text-wrap">{item.title}</h4>
            <p className="mb-0">{item.desc}</p>
          </div>
        </div>
      );
    })}
  </div>
</div>


      {/* Mission & Vision */}
      <div className="container " style={sectionSpacing}>
        <h2 className="fw-bold text-center mb-5">Our Mission & Vision</h2>
        <div className="row flex-column-reverse flex-sm-row align-items-center g-4 two-grid">

          {/* Mission */}
          <div className="col-sm-6 px-3 px-sm-4">
            <div
              style={{
                background: 'linear-gradient(180deg, #1e4762 0%, #1a2940 100%)',
                color: '#e5e2e2',
                padding: '40px',
                borderRadius: '16px',
                height: '100%',
                boxShadow: '0 6px 20px rgba(0,0,0,0.2)'
              }}
            >
              <h3 className="fw-bold mb-3">Our Mission</h3>
              <h5 className="fst-italic text-warning mb-3">Precision and quality in every print</h5>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                To revolutionize printing by blending affordability, speed, and top-notch quality — making every customer's printing journey seamless and memorable. We focus on results, not just ink.
              </p>
            </div>
            <img src="/img/sec3.jpg" alt="Efficient Printing" className="w-100 mt-4" style={roundedImg} />
          </div>

          {/* Vision */}
          <div className="col-sm-6 px-3 px-sm-4">
            <img src="/img/sec4.jpg" alt="Cost Effective" className="w-100 mb-3" style={roundedImg} />
            <div
              style={{
                background: 'linear-gradient(180deg, #1e4762 0%, #1a2940 100%)',
                color: '#e5e2e2',
                padding: '40px',
                borderRadius: '16px',
                height: '100%',
                boxShadow: '0 6px 20px rgba(0,0,0,0.2)'
              }}
            >
              <h3 className="fw-bold mb-3">Our Vision</h3>
              <h5 className="fst-italic text-warning mb-3">Empowering people through accessible design</h5>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                To become the most loved and trusted printing brand by inspiring creativity, empowering businesses, and making quality prints accessible to all — everywhere, anytime.
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};


export default AboutUs;
